export const FETCH_SITEMAP = 'FETCH_SITEMAP';
export const FETCH_SITEMAP_SUCCESS = 'FETCH_SITEMAP_SUCCESS';
export const FETCH_SITEMAP_FAILED = 'FETCH_SITEMAP_FAILED';
